import request from '@/utils/request'

// 获取导航栏目信息
export function queryNavigation(data) {
  return request({
    url: '/navigation/info/list',
    method: 'get',
    params:data
  })
}